import { IEssayBody } from '../../../core/models/essay';
import { sendEssay } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

export function useSendEssay(callback: (status: boolean) => void) {
  const { mutate, isPending, isError, data } = useMutation({
    mutationKey: ['sendEssay'], 
    mutationFn: (body: IEssayBody) => sendEssay(body),
    onSuccess: (response: any) => {
      if(response.id) {
        callback(true);
      }
    },
    retry: false
  });

  return { mutate, isPending, isError, data };
}